{% block sw_order_detail_content_tabs_general %}
    {% parent %}

{# sw-tabs-item will dissappear. See: https://github.com/shopware/shopware/blob/trunk/UPGRADE-6.7.md#sw-tabs-is-removed #}
<sw-tabs-item v-if="isPostFinanceCheckoutPayment"
			  :route="{ name: 'postfinancecheckout.order.detail', params: { id: $route.params.id } }"
			  :title="$tc('postfinancecheckout-order.header')">
	{{ $tc('postfinancecheckout-order.header') }}
</sw-tabs-item>
{% endblock %}

{% block sw_order_detail_actions_slot_smart_bar_actions %}
<template v-if="isEditable">
	{% parent %}
</template>
{% endblock %}
